(function () {
    let currentIndex = 0;
    let cardsPerView = 5;

    function getCardsPerView() {
        const width = window.innerWidth;
        if (width <= 480) return 2;
        if (width <= 768) return 2;
        if (width <= 1024) return 3;
        if (width <= 1200) return 4;
        return 5;
    }

    function checkAndShowNavigation() {
        const grid = document.getElementById('productGrid');
        const prevBtn = document.querySelector('.carousel-nav.prev');
        const nextBtn = document.querySelector('.carousel-nav.next');

        if (!grid || !prevBtn || !nextBtn) return;

        const totalCards = grid.children.length;
        cardsPerView = getCardsPerView();

        // Show BOTH buttons only if we have MORE cards than can fit in view
        if (totalCards > cardsPerView) {
            prevBtn.style.display = 'flex';
            nextBtn.style.display = 'flex';
            prevBtn.style.visibility = 'visible';
            nextBtn.style.visibility = 'visible';
        } else {
            // Hide BOTH buttons if scrolling not needed
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
        }

        // Update button disabled states
        updateButtons();
    }

    window.scrollCarousel = function (direction) {
        const grid = document.getElementById('productGrid');
        if (!grid) return;

        const cards = Array.from(grid.children);
        const totalCards = cards.length;
        const maxIndex = Math.max(0, totalCards - cardsPerView);

        currentIndex += direction;

        // Boundary checks
        if (currentIndex < 0) currentIndex = 0;
        if (currentIndex > maxIndex) currentIndex = maxIndex;

        // Calculate scroll amount
        const cardWidth = cards[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(grid).gap) || 20;
        const scrollAmount = (cardWidth + gap) * currentIndex;

        grid.style.transform = `translateX(-${scrollAmount}px)`;

        updateButtons();
    };

    function updateButtons() {
        const grid = document.getElementById('productGrid');
        const prevBtn = document.querySelector('.carousel-nav.prev');
        const nextBtn = document.querySelector('.carousel-nav.next');

        if (!grid || !prevBtn || !nextBtn) return;

        const totalCards = grid.children.length;
        const maxIndex = Math.max(0, totalCards - cardsPerView);
        if (currentIndex === 0) {
            // At start - disable prev, keep next enabled
            prevBtn.disabled = true;
            prevBtn.style.opacity = '0.3';
            prevBtn.style.cursor = 'not-allowed';
        } else {
            // Not at start - enable prev
            prevBtn.disabled = false;
            prevBtn.style.opacity = '1';
            prevBtn.style.cursor = 'pointer';
        }

        if (currentIndex >= maxIndex) {
            // At end - disable next, keep prev enabled
            nextBtn.disabled = true;
            nextBtn.style.opacity = '0.3';
            nextBtn.style.cursor = 'not-allowed';
        } else {
            // Not at end - enable next
            nextBtn.disabled = false;
            nextBtn.style.opacity = '1';
            nextBtn.style.cursor = 'pointer';
        }
    }

    // Reset on window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            currentIndex = 0;
            const grid = document.getElementById('productGrid');
            if (grid) {
                grid.style.transform = 'translateX(0)';
            }
            checkAndShowNavigation();
        }, 250);
    });

    function initCarousel() {
        checkAndShowNavigation();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarousel);
    } else {
        initCarousel();
    }
    window.addEventListener('load', checkAndShowNavigation);
})();

function printRecipePDF() {
    const recipeData = JSON.parse(
      document.getElementById('recipe-data').textContent
    );
  
    const pdfHTML = buildRecipePDFHTML(recipeData);
  
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const html = `
    <html>
      <head>
        <style>
          @page { size: A4; margin: 12mm; }
          body { margin: 0; font-family: Arial, sans-serif; }
          img { max-width: 100%; height: auto; page-break-inside: avoid; }
          h1, h2 { page-break-after: avoid; }
        </style>
      </head>
      <body>${pdfHTML}</body>
    </html>
    `;
    // const navigateBack = () => {
    //   window.history.back(); // or window.location.href = '/target'
    // };
    const target = isMobile
      ? window.open('', '_blank')
      : (() => {
          const iframe = document.createElement('iframe');
          Object.assign(iframe.style, {
            position: 'fixed',
            width: '0',
            height: '0',
            border: '0'
          });
          document.body.appendChild(iframe);
          return iframe.contentWindow;
        })();
    
    const doc = target.document;
    doc.open();
    doc.write(html);
    doc.close();
    
    target.focus();
    // trigger print first
    setTimeout(() => target.print(), 500);
  }
  function buildRecipePDFHTML(data) {
    const metaHTML = getRecipeMetaHTML();
    return `
      <!-- TITLE -->
      <style>
      body { font-family: -apple-system, BlinkMacSystemFont, Arial, sans-serif; }
      h1 { font-size: 24px; margin-bottom: 8px; }
      h2 { font-size: 18px; margin-top: 20px; }
  
      /* ================= TITLE ================= */
      .pdf-title {
        text-align: center;
        font-size: 18pt;
        margin-bottom: 22px;
        font-weight: 600;
      }
      
      /* ================= TOP ROW ================= */
      .pdf-top-row {
        display: flex;
        gap: 20px;
        align-items: flex-start;
        margin-bottom: 26px;
      }
      
      /* IMAGE CARD */
      .pdf-image img {
        max-width: 350px;
        height: auto;
        border-radius: 16px;
        border: 2px solid #e5e7eb;
        padding: 4px;
        background: #fff;
        page-break-inside: avoid;
      }
      
      /* ================= META ================= */
      .pdf-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 1.5vh;
      }
      .recipe-meta-item svg {
        display: inline-block;
        width: 14px;
        height: 14px;
        fill: currentColor;
      }
      .recipe-meta-item {
        border: 1px solid #000;
        padding: 6px 10px;
        font-size: 10pt;
        white-space: nowrap;
        background: #fff;
        border-radius: 6px;
      }
      
      .recipe-meta-item svg {
        display: none;
      }
      
      /* ================= SECTIONS ================= */
      section {
        margin-bottom: 28px;
      }
      
      /* SECTION TITLES */
      .pdf-ingredients-title,
      .pdf-directions-title {
        text-align: center;
        font-size: 12pt;
        font-weight: 600;
        margin-bottom: 14px;
      }
      
      .pdf-ingredients-title {
        color: #0b2a63;
      }
      
      .pdf-directions-title {
        color: #c62828;
      }
      
      /* ================= INGREDIENTS ================= */
     
      .ingredient-item {
        font-size: 10pt;
        line-height: 1.8;
        padding-left: 14px;      /* space for bullet */
        text-indent: -9px;     /* pull first line back */
        break-inside: avoid;
      }
      .ingredient-item::before {
        content: "• ";
        flex-shrink: 0;
      }

      .pdf-ingredients {
        column-count: 2;
        column-gap: 18px;
        padding: 14px;
        background: #f0f7ff;
        border: 2px solid #0b2a63;
        border-radius: 14px;
        list-style: none;
        margin: 0;
      }
      
      .pdf-ingredients li {
        display: inline-block;
        width: 100%;
        background: #fff;
        border: 1px solid #0b2a63;
        border-radius: 10px;
        padding: 6px 8px;
        font-size: 10pt;
        margin-bottom: 10px;
        break-inside: avoid;
      }
      /* ================= DIRECTIONS ================= */
      .pdf-directions {
        list-style: decimal;
        padding: 14px 18px;
        margin: 0;
        background: #fff5f5;
        border: 2px solid #c62828;
        border-radius: 14px;
      }
      .pdf-directions,
      .direction-step {

        page-break-inside: auto !important;
        break-inside: auto !important;
      }
      
  
      .direction-step {
        counter-increment: step;
        display: flex;
        align-items: flex-start;
        gap: 6px;
        font-size: 10pt;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #c62828;
      }
      .direction-step::before {
        content: "Step " counter(step) ":";
        color: #c62828;
        font-weight: 600;
        white-space: nowrap;
      }
      .dir-step-num {
        display: none;
      }
      
      .dir-step-text {
        display: block;
      }
      .direction-step:last-child {
        border-bottom: none;
      }
      
      /* ================= IMAGES ================= */
      img {
        max-width: 100%;
        height: auto;
        page-break-inside: avoid;
      }
      .print-logo-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 16px;
      }
      
      .print-logo-container img {
        display: block;
      }
      
      /* ================= PRINT SAFETY ================= */
      @page {
        size: A4;
        margin: 12mm;
      }
    </style>
    <div class="print-logo-container">
    <img
      src="https://cdn.shopify.com/s/files/1/0940/3183/9516/files/Branding_Carolina_Cooker_Logo_Shape.png?v=1764162017"
      alt="Carolina Cooker Logo"
      width="300"
      height="300"
      style="width: 150px; height: auto;"
    >
  </div>
      <h1 class="pdf-title">${data.title}</h1>
  
      <!-- IMAGE + META -->
      <div class="pdf-top-row">
        ${data.image ? `
          <div class="pdf-image">
            <img src="${data.image}" />
          </div>` : ''}
  
        <div class="pdf-meta">
          ${metaHTML}
        </div>
      </div>
      <section>
      <h2 class="pdf-ingredients-title">Ingredients</h2>
      <ul class="pdf-ingredients">
        ${getAttributesHTML('.ingredients-box')}
      </ul>
      </section>
      <section>
      <h2 class="pdf-directions-title">Directions</h2>
      <ol class="pdf-directions">
        ${getAttributesHTML('.directions-box')}
      </ol>
    </section>
    `;
  }

  function getAttributesHTML(className) {
    const el = document.querySelector(className);
    if (!el) return '';
  
    const clone = el.cloneNode(true);
    const title = clone.querySelector('h2');
    if (title) title.remove();
  
    return clone.innerHTML;
  }
  
  function cleanHTMLList(html = '') {
    return html
      .replace(/<li>/gi, '')
      .replace(/<\/li>/gi, '||')
      .replace(/<ul>|<\/ul>/gi, '')
      .replace(/<ol>|<\/ol>/gi, '')
      .replace(/<p>/gi, '')
      .replace(/<\/p>/gi, '||')
      .replace(/<[^>]+>/g, '') // strip any remaining tags
      .split('||')
      .map(i => i.trim())
      .filter(Boolean);
  }
  function getRecipeMetaHTML() {
    const meta = document.querySelector('.recipe-meta-list');
    return meta ? meta.innerHTML : '';
  }

function shareOnFacebook(url, title) {
    event.preventDefault();
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
}

function shareOnTwitter(url, title) {
    event.preventDefault();
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
}